import { USER_ROLE_LEVEL } from '../constants';
import { UserRole } from '../types';

export function hasSufficientRoleLevel(
  userRole: UserRole,
  requiredRole: UserRole,
): boolean {
  return USER_ROLE_LEVEL[userRole] >= USER_ROLE_LEVEL[requiredRole];
}
